import Axios from 'axios'
import {identificationTypeUrls} from '../urls'
import router from '../../../router'

export default {
  get_all_identification_types (context) {
    Axios.get(identificationTypeUrls.getAllIdentificationTypes).then(function (response) {
      context.commit('GET_ALL_IDENTIFICATION_TYPES', response.data)
    })
  },
  get_identification_types (context, publicId) {
    Axios.get(identificationTypeUrls.getIdentificationTypes + publicId).then(function (response) {
      context.commit('GET_IDENTIFICATION_TYPES', response.data)
    })
  },
  get_deleted_identification_types (context) {
    Axios.get(identificationTypeUrls.getDeletedIdentificationType).then(function (response) {
      context.commit('GET_DELETED_IDENTIFICATION_TYPES', response.data)
    })
  },
  get_identification_type (context, publicId) {
    Axios.get(identificationTypeUrls.getIdentificationType + publicId).then(function (response) {
      context.commit('GET_IDENTIFICATION_TYPE', response.data)
    })
  },
  post_identification_type (context, data) {
    Axios.post(identificationTypeUrls.postIdentificationType, data).then(function () {
      context.dispatch('get_all_identification_types')
    }).catch(function (error) {
      // console.log(error.data)
    })
  },
  update_identification_type (context, data) {
    Axios.patch(identificationTypeUrls.editIdentificationType, data).then(function () {
      context.dispatch('get_all_identification_types')
    }).catch(function (error) {
      // console.log(error.data)
    })
  },
  delete_identification_type (context, data) {
    Axios.patch(identificationTypeUrls.deleteIdentificationType, data).then(function () {
      context.dispatch('get_all_identification_types')
    })
  },
  restoreIdentificationType (context, publicId) {
    Axios.get(identificationTypeUrls.restoreIdentificationType + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_IDENTIFICATION_TYPES', response.data)
      router.push({
        name: 'Module.IdentificationTypes'
      })
    })
  }
}
